import React from 'react';
import TwoColumn from '../../components/TwoColumn';
import Main from './Main';

import './styles.css';

export default function Recognition() {
  return (
    <TwoColumn>
      <TwoColumn.Left>
        <Main />
      </TwoColumn.Left>
      <TwoColumn.Right />
    </TwoColumn>
  );
}
